import { Stack } from "@mui/material";
import { t } from "i18next";
import oliviaIcon from "../../../assets/oliviaIcon.png";
import { useAISupportChat } from "../../../context/useAISupportChat";
import { useAuthStore } from "../../../stores";
import { ButtonDigited } from "../../Button/Button.variants";

export function SupportAiButton() {
  const { openChat } = useAISupportChat();
  const enablePreloginChatbot = useAuthStore(state =>
    state.userMgmtData?.enable_prelogin_chatbot ?? state.corporateInfo?.enable_prelogin_chatbot);

  if (enablePreloginChatbot === false) return null;

  return (
    <ButtonDigited
      typology="secondary"
      aria-label={ t("support_ai") }
      onClick={ () => openChat(true) }
    >
      <Stack alignItems="center" component="span" direction="row" gap="0.5rem">
        <img src={ oliviaIcon } alt="" aria-hidden="true" width={ 24 } height={ 24 } />
        { t("support_ai") }
      </Stack>
    </ButtonDigited>
  );
}
